export default __webpack_public_path__ + "static/media/blue-back.6ee7bedb.svg";